export default {
  path: 'profile/workbench',
  name: 'UserWorkbench',
  component: () => import('@/pages/user/profile/Index'),
  meta: { title: '工作台' }
}
